import { useState, useEffect } from "react";
import axios from "axios";

const Dashboard = () => {
  const [user, setUser] = useState({});

  const getUser = async () => {
    const token = localStorage.getItem("token");
    try {
      const { data } = await axios.get("http://localhost:3001/dashboard", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUser(data);
    } catch (error) {
      localStorage.removeItem("token");
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center bg-gray-800">
      <p className="pl-6 mt-16 w-full text-2xl text-white">Dashboard</p>
      <div className="p-4 mt-16 w-3/4 flex flex-col justify-center items-center bg-white shadow-sm">
        <h1>{`Hello, ${user.username}!`}</h1>
        <p>Welcome to your Dashboard.</p>
        <p>You can upload your NFTs here</p>
      </div>
      <p className="mt-4 text-white">New NFT</p>
      <form className="p-4 flex flex-col bg-gray-300 h-56 w-3/4">
        <label>NFT name</label>
        <input type="text" />
        <label>NFT description</label>
        <input type="text" />
        <button type="submit" className="p-1 mt-4 bg-yellow-200 rounded-sm">
          Create NFT
        </button>
      </form>
    </div>
  );
};

export default Dashboard;
